import React, { useEffect, useRef } from "react";
import Select from "../Common/FormElements/Select/Select";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAffiliates } from "../../REDUX/actions/affiliate";
import { getCountries } from "../../REDUX/actions/country";

export const prospectStatusOptions = (t) => [
  {
    name: t("Prospect"),
    code: "Prospect",
  },
  {
    name: t("Interested"),
    code: "Interested",
  },
  {
    name: t("In discussion"),
    code: "In discussion",
  },
  {
    name: t("Pending signature"),
    code: "Pending signature",
  },
];

const ProspectsFilters = ({ filters, setFilters }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { affiliates } = useSelector((state) => state.affiliateReducer);
  const { countries } = useSelector((state) => state.countryReducer);
  const { user } = useSelector((state) => state.userReducer);

  const userRole = user?.attributes?.userRole;
  const isManager = userRole === 2;
  const isAdmin = userRole === 1;

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    if (name === "business_affiliate") {
      setFilters((prev) => ({
        ...prev,
        reseller: null,
        [name]: value,
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getAffiliatesOptions = () =>
    affiliates.map((affiliate) => {
      return {
        name: affiliate?.attributes?.company,
        code: affiliate?.id,
      };
    });

  const affiliatesAbortRef = useRef(null);
  const countriesAbortRef = useRef(null);

  useEffect(() => {
    if (user?.attributes?.userRole === 1) {
      affiliatesAbortRef.current?.abort();
      affiliatesAbortRef.current = new AbortController();
      dispatch(getAffiliates(affiliatesAbortRef.current.signal));
    }
    return () => {
      affiliatesAbortRef.current?.abort();
    };
  }, [user, dispatch]);

  useEffect(() => {
    countriesAbortRef.current?.abort();
    countriesAbortRef.current = new AbortController();
    dispatch(getCountries(false, countriesAbortRef.current.signal));
    return () => {
      countriesAbortRef.current?.abort();
    };
  }, [dispatch]);

  return (
    <>
      {(isManager || isAdmin) && (
        <div className="py-2 d-flex gap-3 w-100">
          <div className="max-w-300px w-100">
            <Select
              name="status"
              value={filters.status}
              label={t("Status")}
              placeholder={t("Status")}
              options={prospectStatusOptions(t)}
              resetable
              showClear
              appendToSelf
              callback={handleFilterChange}
            />
          </div>
          <div className="max-w-300px w-100">
            <Select
              name="country"
              value={filters.country}
              label={t("Country")}
              placeholder={t("Country")}
              options={countries}
              filter
              resetable
              showClear
              appendToSelf
              callback={handleFilterChange}
            />
          </div>
          {isAdmin && (
            <div className="max-w-300px w-100">
              <Select
                name="business_affiliate"
                value={filters.business_affiliate}
                label={t("Manager")}
                placeholder={t("Manager")}
                filter
                appendToSelf
                showClear
                resetable
                options={getAffiliatesOptions()}
                callback={handleFilterChange}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ProspectsFilters;
